import { Component, OnInit } from '@angular/core';
import { SAMSessionService } from 'src/app/sam/sam-session.service';
import { BasePaymentPage } from 'src/app/base/payment-page';
import { NavController, ModalController, NavParams } from '@ionic/angular';
import { SAMService } from 'src/app/sam/sam.service';
import { ConfigService } from 'src/app/config.service';
import { GUIService } from '../../gui.service';
import { CartService } from 'src/app/services/cart.service';
import { WindowRef } from '../../../window-ref.service';
import { I18NService } from '../../../services/i18n.service';

@Component({
  selector: 'app-sco-payment-dialog',
  templateUrl: './sco-payment-dialog.page.html',
  styleUrls: ['./sco-payment-dialog.page.scss'],
})
export class SCOPaymentDialogPage extends BasePaymentPage {

  constructor(
    public samSessionSvc: SAMSessionService,
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    public sam: SAMService,
    public configSvc: ConfigService,
    public guiSvc: GUIService,
    public cartSvc: CartService,
    public winRef: WindowRef,
    public i18nSvc: I18NService
  ) {
    super(navCtrl, modalCtrl, navParams, sam, configSvc, guiSvc, cartSvc, winRef);
  }

  // never implement lifecycle hooks as they are already implemented on BasePaymentPage

  setTenderColor(tender: any) {
    if (tender.IsGlory) {
      return 'success';
    } else {
      return 'tertiary';
    }
  }
}
